'use client';

import { Box, Skeleton, VStack, Stack, HStack, Text } from '@chakra-ui/react';
import { MdOutlinePsychology, MdOutlineVolunteerActivism } from 'react-icons/md';

import CustomTag from '@components/Custom-text/CustomTag';
import { Mentor } from '@modules/auth/types';

interface ProfileTagsProps {
    mentorFullProfileInfo: Mentor;
    relevantSkills?: string[];
    isLoading: boolean;
}

const ProfileTags = ({ mentorFullProfileInfo, relevantSkills, isLoading }: ProfileTagsProps) => {
    const expertise = mentorFullProfileInfo?.skills || [];
    const skills = relevantSkills || [];

    return (
        <Box p="24px" borderWidth="1px" borderRadius="md">
            <VStack align="start" spacing={6}>
                {/* Expertise */}
                <Stack>
                    <HStack mb={2}>
                        <Box
                            width="28px"
                            height="28px"
                            bgColor="blue.100"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="4px"
                        >
                            <MdOutlinePsychology
                                color="#2563EB"
                                size="20px"
                                style={{ transform: 'scaleX(-1)' }}
                            />
                        </Box>
                        <Text fontWeight={500} fontFamily="Fira Sans" color="titleText">
                            Expertise
                        </Text>
                    </HStack>
                    {isLoading ? (
                        <HStack spacing={2} flexWrap="wrap">
                            {Array.from({ length: 6 }).map((_, idx) => (
                                <Skeleton key={idx} height="28px" width="120px" borderRadius="md" />
                            ))}
                        </HStack>
                    ) : (
                        <CustomTag
                            heading=""
                            values={expertise}
                            tagBorderColor="border"
                            tagBgColor="transparent"
                            tagColor="mainText"
                            tagFontWeight={400}
                        />
                    )}
                </Stack>

                {/* Mentorship Skills */}
                {!!skills.length && (
                    <Stack>
                        <HStack mb={2}>
                            <Box
                                width="28px"
                                height="28px"
                                bgColor="teal.100"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                borderRadius="4px"
                            >
                                <MdOutlineVolunteerActivism color="#14B8A6" size="20px" />
                            </Box>
                            <Text fontWeight={500} fontFamily="Fira Sans" color="titleText">
                                Mentorship Skills
                            </Text>
                        </HStack>
                        {isLoading ? (
                            <HStack spacing={2} flexWrap="wrap">
                                {Array.from({ length: 5 }).map((_, idx) => (
                                    <Skeleton
                                        key={idx}
                                        height="28px"
                                        width="180px"
                                        borderRadius="md"
                                    />
                                ))}
                            </HStack>
                        ) : (
                            <CustomTag
                                heading=""
                                values={skills}
                                tagBorderColor="border"
                                tagBgColor="transparent"
                                tagColor="mainText"
                                tagFontWeight={400}
                            />
                        )}
                    </Stack>
                )}
            </VStack>
        </Box>
    );
};

export default ProfileTags;
